import { AnyAction } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  AngebotsId,
  CheckoutProdukt,
  GlobalActions,
  ProduktDeleted,
} from '@ps20-frontend/shop-integration-redux';
import { FEVorvertragsnummer } from '@ps20-frontend/frontend-models';
import {
  VorliegendeKuendigung,
  VorliegendeKuendigungChanged,
} from '../interfaces/vorliegendeKuendigung';
import { ToolbarActions } from '../toolbar.actions';

export const vorliegendeKuendigungenReducer = function (
  sectionState: Array<VorliegendeKuendigung> = null,
  action: AnyAction,
): Array<VorliegendeKuendigung> {
  switch (action.type) {
    case GlobalActions.PRODUKT_ACTION: {
      const produkt: CheckoutProdukt = action.payload;

      if (shouldAddNewKuendigungItem(sectionState, produkt)) {
        const vorversicherungToAdd: VorliegendeKuendigung = {
          appId: produkt.appId,
          angebotsId: produkt.angebotsId,
          gekuendigt: false,
          gekuendigtTemp: false,
          vorvertragsnummer:
            produkt.vorvertragsnummer && produkt.vorvertragsnummer[0].vertragsnummer,
          versicherungname: produkt.uebersichtTitle,
          info: produkt.versichertesRisiko,
          ausserhalbDeltaRange: false,
        };
        return [...sectionState, vorversicherungToAdd];
      }
      return sectionState;
    }
    case ToolbarActions.KUENDIGUNG_CHANGED: {
      const actionPayload: VorliegendeKuendigungChanged = action.payload;
      const newState: Array<VorliegendeKuendigung> = cloneDeep(sectionState);

      const elementToUpdate = newState.find(elem => {
        return elem.vorvertragsnummer === actionPayload.vorvertragsnummer;
      });

      if (elementToUpdate) {
        elementToUpdate.gekuendigtTemp = actionPayload.checked;
      }

      return newState;
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      return sectionState.map(kuendigungen => {
        if (kuendigungen.gekuendigtTemp) {
          return {
            ...kuendigungen,
            gekuendigt: true,
          };
        }
        return kuendigungen;
      });
    }
    case GlobalActions.OUT_OF_DELTA_RANGE: {
      const newState: Array<VorliegendeKuendigung> = cloneDeep(sectionState);
      const actionPayload: AngebotsId = action.payload;

      newState
        .filter(
          kuendigungen =>
            kuendigungen.appId === actionPayload.appId &&
            kuendigungen.angebotsId === actionPayload.angebotsId,
        )
        .forEach(kuendigungen => {
          kuendigungen.ausserhalbDeltaRange = true;
        });

      return newState;
    }
    case GlobalActions.PRODUKT_DELETED: {
      let newState: Array<VorliegendeKuendigung> = cloneDeep(sectionState);
      const actionPayload: ProduktDeleted = action.payload;

      newState = newState.filter(elem => {
        return !actionPayload.angebotsIds.some(
          angebotsId =>
            angebotsId.appId === elem.appId && angebotsId.angebotsId === elem.angebotsId,
        );
      });

      return newState;
    }
    default:
      return sectionState;
  }
};

function kuendingNotAlreadyExisting(
  sectionState: Array<VorliegendeKuendigung>,
  produkt: CheckoutProdukt,
): boolean {
  return !sectionState.some(
    stateVorliegendeKuendigung =>
      produkt.appId === stateVorliegendeKuendigung.appId &&
      produkt.angebotsId === stateVorliegendeKuendigung.angebotsId,
  );
}

function shouldAddNewKuendigungItem(
  sectionState: Array<VorliegendeKuendigung>,
  produkt: CheckoutProdukt,
): FEVorvertragsnummer[] {
  return kuendingNotAlreadyExisting(sectionState, produkt) && produkt.vorvertragsnummer;
}
